var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
var SidebarResourcesItem = /** @class */ (function (_super) {
    __extends(SidebarResourcesItem, _super);
    function SidebarResourcesItem(props) {
        var _this = _super.call(this, props) || this;
        _this.trackClicks = _this.trackClicks.bind(_this);
        return _this;
    }
    SidebarResourcesItem.prototype.trackClicks = function (text) {
        window.neo4jSandbox.tracking.event('SANDBOX_SIDEBAR_CLICK', { text: text });
    };
    SidebarResourcesItem.prototype.render = function () {
        var _this = this;
        return (React.createElement(Menu, { vertical: true, fluid: true, size: "large", className: "box-shadow no-border" }, this.props.sections.map(function (s, i) { return (React.createElement(Menu.Item, { key: i, className: "px4 py3" },
            React.createElement(Menu.Header, { id: s.id, as: s.url ? 'a' : 'div', href: s.url || null, className: "color-charcoal" }, s.title),
            React.createElement(Menu.Menu, null, s.items &&
                s.items.map(function (item, j) { return (React.createElement(Menu.Item, { link: true, href: item.url, target: "_blank", key: j, content: item.text, name: item.text, onClick: function () { return _this.trackClicks(item.text); }, id: item.id })); })))); })));
    };
    return SidebarResourcesItem;
}(Component));
export default SidebarResourcesItem;
